import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  StyledSummaryProfile,
  StyledBoxCentral,
  StyledBoxExperienceInfo,
  StyledBoxInfo,
  StyledBoxDual,
  StyledEducation,
  StyledWrapEmployeeInfoInterest,
  StyledBoxProjects,
  StyledProjects,
  StyledProfileName,
  StyledProfileDpto,
  StyledHobbiesUser,
  StyledButtonAvatar,
  StyledAvatarPerson,
  StyledProfile,
  StyledProfileBlock,
  StyledProfileFlex,
  StyledProfileImg,
  StyledLink
} from './style';

import {
  SOCIAL,
  ABOUT_YOU,
  HOBBIES,
  LANGUAGE,
  EDUCATION
} from '../../../../constants/modals';

import {
  getConsultants,
  getDepartments,
  getSubDepartments,
  getLocations
} from '../../../../utils/apiDataUserForm';
import { parseSelect } from '../../../../utils/parseSelect';
import { OurTeam } from '../../../core/OurTeam';

import Languages from '../../../core/BoxEmployeeInfo/Languages';
import ModalAvatar from '../ChangeAvatar';
import { AVATAR_MEDIUM, getCropWithPath } from '../../../../utils/crops';

const Profile = ({
  idUser,
  isWidget,
  dataLanguage,
  dataEducations,
  dataHobbies,
  dataUser,
  dataTeam,
  dataSocial,
  imgSociety,
  editMode,
  clickEditIconHandler,
  sameUser,
  educationsPublic,
  languagesPublic,
  hobbiesPublic,
  dataProjects
}) => {
  const [dpto, setDtpo] = useState('');
  const [subDpto, setSubDtpo] = useState('');
  const [areaDpto, setAreaDpto] = useState('');
  const [consultant, setConsultant] = useState('');
  const [location, setLocation] = useState('');
  const [editAvatar, setEditAvatar] = useState(false);

  useEffect(() => {
    if (dataUser.idDepartment) {
      getDepartments().then(dpt => {
        setDtpo(
          parseSelect(dpt).filter(
            dtp => dtp.value === dataUser.idDepartment.toString()
          )[0].text
        );
      });
      if (dataUser.idSubDepartment) {
        getSubDepartments(dataUser.idDepartment).then(dpt => {
          setSubDtpo(
            `- ${
              parseSelect(dpt).filter(
                dtp => dtp.value === dataUser.idSubDepartment.toString()
              )[0].text
            }`
          );
          getSubDepartments(dataUser.idSubDepartment).then(areas => {
            if (dataUser.idArea) {
              const areaSelected = parseSelect(areas).filter(
                area => area.value === dataUser.idArea.toString()
              );
              if (areaSelected && areaSelected.length > 0) {
                setAreaDpto(`- ${areaSelected[0].text}`);
              }
            }
          });
        });
      }
      Promise.resolve(getConsultants()).then(res => {
        const consult = res.find(cons => cons.id === dataUser.idPartnerCompany);
        setConsultant(consult && consult.name);
      });
    }
    if (dataUser.location) {
      getLocations().then(locations => {
        const location = locations.filter(
          l => Object.keys(l)[0] === dataUser.location
        );
        setLocation(location[0][dataUser.location]);
      });
    }
  }, []);

  const toggleEditAvatar = editState => setEditAvatar(editState);
  const renderProfileWidget = () => {
    if (isWidget === true) {
      return (
        <StyledProfileFlex isWidget={isWidget}>
          <StyledProfileBlock isWidget={isWidget} left>
            <StyledProfile full>
              <StyledAvatarPerson
                name={dataUser.name}
                lastname={dataUser.lastname}
                userId={String(dataUser.userId)}
                crop={getCropWithPath(String(dataUser.userId)) || AVATAR_MEDIUM}
                avatarPhoto={dataUser.avatarPhoto}
                full
              />
            </StyledProfile>
          </StyledProfileBlock>
          <StyledProfileBlock isWidget={isWidget} right>
            <StyledProfileName isWidget={isWidget}>{`${dataUser.publicName ||
              dataUser.name} ${dataUser.lastname || ''}`}</StyledProfileName>
            {dataUser.typology.includes('INTERNAL') && (
              <StyledProfileDpto
                isWidget={isWidget}
              >{`${dpto} ${subDpto} ${areaDpto}`}</StyledProfileDpto>
            )}
            <StyledProfileDpto
              isWidget={isWidget}
            >{`Centro ${location}`}</StyledProfileDpto>
            {dataUser.typology.includes('INTERNAL') && (
              <StyledProfileDpto
                isWidget={isWidget}
              >{`${dataUser.jobPosition}`}</StyledProfileDpto>
            )}
            {dataUser.typology.includes('EXTERNAL') && (
              <>
                <StyledProfileDpto
                  isWidget={isWidget}
                >{`${consultant}`}</StyledProfileDpto>
                {!isWidget && <StyledProfileImg src={`${imgSociety}`} />}
              </>
            )}
          </StyledProfileBlock>
        </StyledProfileFlex>
      );
    }
    return (
      <StyledProfileFlex>
        <StyledProfileBlock right>
          <StyledProfileName>{`${dataUser.publicName ||
            dataUser.name} ${dataUser.lastname || ''}`}</StyledProfileName>
          {dataUser.typology.includes('INTERNAL') && (
            <StyledProfileDpto>{`${dpto} ${subDpto} ${areaDpto}`}</StyledProfileDpto>
          )}
          <StyledProfileDpto>{`Centro ${location}`}</StyledProfileDpto>
          {dataUser.typology.includes('INTERNAL') && (
            <StyledProfileDpto>{`${dataUser.jobPosition}`}</StyledProfileDpto>
          )}
          {dataUser.typology.includes('EXTERNAL') && (
            <>
              <StyledProfileDpto>{`${consultant}`}</StyledProfileDpto>
              <StyledProfileImg src={`${imgSociety}`} />
            </>
          )}
        </StyledProfileBlock>
        <StyledProfileBlock left>
          <StyledProfile full>
            <StyledAvatarPerson
              name={dataUser.name}
              lastname={dataUser.lastname}
              userId={String(dataUser.userId)}
              crop={getCropWithPath(String(dataUser.userId)) || AVATAR_MEDIUM}
              avatarPhoto={dataUser.avatarPhoto}
              full
            />
          </StyledProfile>
        </StyledProfileBlock>
      </StyledProfileFlex>
    );
  };

  return (
    <React.Fragment>
      {renderProfileWidget()}
      {sameUser && (
        <StyledButtonAvatar onClick={() => toggleEditAvatar(true)}>
          {dataUser.avatarPhoto
            ? 'Cambiar foto de Perfil'
            : 'Subir foto de Perfil'}
        </StyledButtonAvatar>
      )}
      {editAvatar && (
        <ModalAvatar hideEditAvatar={() => toggleEditAvatar(false)} />
      )}
      {!isWidget && !sameUser && (
        <OurTeam title="Nuestro equipo" dataTeam={dataTeam} />
      )}
      {!isWidget && (
        <StyledSummaryProfile
          // title={title}
          dataUser={dataUser}
          dataSocial={dataSocial}
          onEditMode={editMode}
          clickEditIcon={() => clickEditIconHandler(ABOUT_YOU)}
          clickSocialEditIcon={() => clickEditIconHandler(SOCIAL)}
        />
      )}
      {dataProjects && (
        <StyledBoxProjects>
          <StyledProjects dataProjects={dataProjects} onEditMode={editMode} />
        </StyledBoxProjects>
      )}
      {!isWidget && (
        <StyledBoxCentral>
          <StyledBoxExperienceInfo>
            <StyledBoxInfo>
              {((dataUser.typology.includes('INTERNAL') && sameUser) ||
                (!sameUser && languagesPublic)) && (
                <StyledWrapEmployeeInfoInterest>
                  <Languages
                    clickEditIcon={() => clickEditIconHandler(LANGUAGE)}
                    dataLanguage={dataLanguage}
                    limit={3}
                    onEditMode={editMode}
                  />
                </StyledWrapEmployeeInfoInterest>
              )}
            </StyledBoxInfo>
          </StyledBoxExperienceInfo>
          <StyledBoxDual>
            {((dataUser.typology.includes('INTERNAL') && sameUser) ||
              (!sameUser && educationsPublic)) && (
              <StyledEducation
                dataEducations={dataEducations}
                limit={2}
                onEditMode={editMode}
                clickEditIcon={() => clickEditIconHandler(EDUCATION)}
              />
            )}
            {(sameUser || (!sameUser && hobbiesPublic)) && (
              <StyledHobbiesUser
                dataHobbies={dataHobbies}
                clickEditIcon={() => clickEditIconHandler(HOBBIES)}
                limit={3}
                onEditMode={editMode}
              />
            )}
          </StyledBoxDual>
        </StyledBoxCentral>
      )}
      {isWidget && (
        <StyledLink href={`/perfil/${idUser}/mi_perfil`} target="_blank">
          Ver Perfil Completo
        </StyledLink>
      )}
    </React.Fragment>
  );
};

Profile.propTypes = {
  // title: PropTypes.string,
  dataUser: PropTypes.shape({
    extension: PropTypes.number,
    mobile: PropTypes.string,
    address: PropTypes.string
  }),
  dataSocial: PropTypes.shape({
    facebook: PropTypes.string,
    instagram: PropTypes.string,
    twitter: PropTypes.string,
    vimeo: PropTypes.string,
    linkedin: PropTypes.string
  }),

  dataLanguage: PropTypes.arrayOf(
    PropTypes.shape({
      language: PropTypes.string,
      level: PropTypes.string,
      certificate: PropTypes.string
    })
  ),
  dataEducations: PropTypes.arrayOf(
    PropTypes.shape({
      degree: PropTypes.string,
      endDate: PropTypes.string,
      schoolName: PropTypes.string,
      startDate: PropTypes.string
    })
  ),
  editMode: PropTypes.bool,
  clickEditIconHandler: PropTypes.func
};

Profile.defaultProps = {
  // title: 'conóceme un poco mejor',
  dataLanguage: []
};

export default Profile;
